import React from 'react';

const TakeVideoBtn = ({ triggerCamera }) => (
  <div onClick={triggerCamera} className="vid-btn btn"/>
);

export default TakeVideoBtn
